export default  [
    {
        name: '6 months',
        value: 6,
        rate: 12
    },{
        name: '8 months',
        value: 8,
        rate: 18
    },{
        name: '12 months',
        value: 12,
        rate: 25
    }
]